<template>
    <b-dropdown
        :append-to-body="true"
        :trigger-tabindex="-1"
        :position="scopeFilterPosition"
        :mobile-modal="false"
        aria-role="list"
        @active-change="onActiveChange">
        <template #trigger>
            <b-button
                :disabled="store.scopeFilterLoading"
                :loading="store.scopeFilterLoading"
                :icon-left="store.filterIcon"
                class="button is-info is-dropdown-trigger">
                {{ getButtonText() }}
            </b-button>
        </template>
        <b-dropdown-item custom>
            <div
                v-if="isDropdownActive"
                class="scope-column-container">
                <single-scope-selector
                    v-if="enableRowSelection"
                    v-model:pinned-scopes="store.selectedScopeFilter"
                    v-model:selected-scope="scopeStore.selectedScope"
                    :scopes="store.scopes" />
                <multi-scope-selector
                    v-else
                    v-model:selected-scopes="store.selectedScopeFilter"
                    v-model:selected-scope="scopeStore.selectedScope"
                    :scopes="store.scopes" />
            </div>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script setup>
    import { useScopeFilterStore } from '@/stores/scopeFilterStore.ts';
    import { useScopeStore } from '@/stores/scopeStore.ts';
    import { onMounted, ref } from 'vue';
    import SingleScopeSelector from '@/shared/components/scopeselector/SingleScopeSelector.vue';
    import MultiScopeSelector from '@/shared/components/scopeselector/MultiScopeSelector.vue';

    const props = defineProps({
        library: {
            type: Object,
            required: true
        },
        scopeFilterPosition: {
            type: String,
            default: 'is-bottom-right'
        },
        enableRowSelection: {
            type: Boolean,
            default: false
        }
    });

    const store = useScopeFilterStore();
    const scopeStore = useScopeStore();
    const isDropdownActive = ref(false);

    onMounted(async () => {
        if (props.library.scopeType) {
            await store.setScopeType(props.library.scopeType);
        }
        await store.init();
    });

    function onActiveChange(active) {
        isDropdownActive.value = active;
    }

    function getButtonText() {
        const defaultLabel = store.scopeType
            ? `${store.scopeType} ${props.enableRowSelection ? 'selector' : 'filter'}`
            : 'Scope filter';
        const count = store.selectedScopeFilter.length;
        return count > 0 ? `${defaultLabel} (${count})` : defaultLabel;
    }
</script>
<style scoped>
.scope-column-container {
    width: max-content;
    font-size: 1.1em;
}

.dropdown-item {
    max-width: 80vw;
    overflow: auto;
}
</style>
